import { jsx as _jsx } from "react/jsx-runtime";
import { DployTextField } from "@ploy-ui/form-fields";
import { useField } from "formik";
export function FormikTextField(props) {
    const { name, helperText, ...rest } = props;
    const [field, meta] = useField(name);
    const error = meta.error;
    const showError = Boolean(error) && meta.touched;
    return (_jsx(DployTextField, { ...rest, ...field, value: field.value ?? "", error: showError, helperText: showError ? error : helperText }));
}
//# sourceMappingURL=FormikTextField.js.map